module.exports = __webpack_public_path__ + "static/img/goldwand.afd966d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/goldwand.jpg
// module id = 295
// module chunks = 0